<template>
    <v-img :src="backgroundUrl" class="mnt_image fill-height">
        <div id="signin_wrapper">
            <v-container fluid>
                <v-row>
                    <v-col cols="12" class="ma-3">
                        <div class="pl-6">
                            <v-icon color="white darken-2" class="mr-3 mt-n1">mdi-ray-end-arrow</v-icon>
                            <a class="return_link sansation white--text text--darken-2" :href="mycompass_url"
                                target="_blank">Go to myCompass</a>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <div id="login" class="elevation-24">
                            <v-img :src="logo_img" width="220" class="d-block" style="margin: 0 auto"
                                atl="Succession Resource Group"></v-img>
                            <div class="sansation grey--text text--darken-3 mt-3 mb-12 font-weight-bold signin_title"
                                v-text="'Admin Sign In'"></div>
                            <v-form v-model="auth_valid" ref="auth_form" @submit.prevent="mfa" v-if="showAccessCodeForm">
                                <div class="text-left">
                                    <h3 class="sansation_subtitle">Check your email for a code</h3>
                                    <p class="sansation">We've sent a 6-character code to your email address. The
                                        code expires shortly, so please enter it soon.</p>
                                </div>

                                <div class="d-block sansation_title text-left">Access Code</div>
                                <div class="d-block">
                                    <v-text-field v-model="accessCode" solo background-color="grey lighten-4"
                                        :rules="accessCodeRules" required ref="mfa_field">
                                        <template v-slot:prepend-inner>
                                            <v-icon color="teal">mdi-email-outline</v-icon>
                                        </template>
                                    </v-text-field>
                                </div>
                                            
                                <v-btn id="login_btn" 
                                    type="submit"
                                    :loading="login_wait" 
                                    :disabled="login_wait"
                                    class="sansation_headline" 
                                    color="teal lighten-5" 
                                    style="height: 50px; color: #333333" 
                                    dark >
                                    Submit
                                </v-btn>

                            </v-form>
                            <form @submit.prevent="logIn" v-if="!showAccessCodeForm">

                                <div class="d-block">
                                    <div class="d-block">
                                        <v-text-field v-model="input.username" solo label="Username"
                                            background-color="grey lighten-4">
                                        </v-text-field>
                                    </div>
                                    <div class="d-block">
                                        <v-text-field v-model="input.password"
                                            :append-icon="show_eye1 ? 'mdi-eye' : 'mdi-eye-off'" solo label="Password"
                                            background-color="grey lighten-4" color="primary darken-1"
                                            :type="show_eye1 ? 'text' : 'password'"
                                            @click:append="show_eye1 = !show_eye1"></v-text-field>
                                    </div>
                                </div>
                                <div class="d-flex justify-center">
                                    <v-btn color="primary darken-1" dark id="login_btn" type="submit" :loading="login_wait" :disabled="login_wait">{{ submit_text }}</v-btn>
                                </div>
                                <div class="d-flex justify-center mt-4">
                                    <v-dialog v-model="forgotDialog" width="40%">
                                        <template v-slot:activator="{ on }">
                                            <v-btn color="primary darken-1" text v-on="on">Forgot Password?</v-btn>
                                        </template>
                                        <v-card>
                                            <v-card-title class="headline grey lighten-2" primary-title>Forgot Password
                                                Reset</v-card-title>

                                            <v-card-text class="mt-2">
                                                Provide us with your email address and we'll send you instructions on
                                                how to
                                                reset your password.
                                                <v-form v-model="valid" ref="form">
                                                    <div class="flex-grow-1 text-center">
                                                        <v-text-field v-model.lazy="reset_email" label="Email Address"
                                                            color="primary" :rules="emailRules" required></v-text-field>
                                                    </div>
                                                    <div class="text-right">
                                                        <v-btn @click="resetClear" class="mr-3">clear</v-btn>
                                                        <v-btn dark @click="resetPass"
                                                            :class="{ red: !valid, 'primary': valid }">Submit</v-btn>
                                                    </div>
                                                </v-form>
                                            </v-card-text>
                                        </v-card>
                                    </v-dialog>
                                </div>
                            </form>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </v-img>
</template>

<script>
import axios from "axios";
import Cookie from 'js-cookie';
import appUrls from '../helpers/environment';
import logo_img from '../assets/SRGLogo_full_color_2022.svg';
import backgroundUrl from '../assets/mycompass_loginbkg_mnt2.jpg';
import getFingerPrint from "../helpers/fingerprint";

export default {
    name: 'SignIn',
    data() {
        return {
            mycompass_url: appUrls.mycompass,
            forgotDialog: false,
            showAccessCodeForm: false,
            submit_text: 'Login',
            input: {
                username: '',
                password: '',
            },
            logo_img: logo_img,
            backgroundUrl: backgroundUrl,
            valid: false,
            reset_email: '',
            show_eye1: false,
            emailRules: [],
            accessCodeRules: [
                (v) => !!v || 'Access Code is required',
                (v) => v.length === 6 || 'Access Code must be 6-characters',
            ],
            login_string: '908257149-a65-4a9o-a99a-24863370939',
            auth_valid: false,
            accessCode: '',
            login_wait: false
        }
    },

    computed: {
        fingerprint() {
            const fingerprint = getFingerPrint();
            return fingerprint;
        }
        // ,
        // login_hotkey() {
        //     return {
        //         enter: this.logIn
        //     }
        // },
        // ,
        // mfa_hotkey() {
        //     return {
        //         enter: this.mfa
        //     }
        // }
    },

    watch: {
        reset_email: function (mail) {
            this.emailRules = [v => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(v) || 'Email must be valid']
        }
    },

    methods: {
        logIn: async function () {
            try {
                if (this.login_wait) return;
                this.login_wait = true;

                const login_res = await axios.post(`${appUrls.api}/api/login/${this.login_string}`, {
                    data: {...this.input, username: this.input.username.trim().toLowerCase(), fingerprint: this.fingerprint},
                    headers: { "content-type": "application/json" }
                })
            
                if ( login_res.data.outcome ) {
                    // console.log(login_res.data)
                    // allow for psudo login
                    if (login_res.data.action == 'login') {
                        // Set secure cookies upon successful login
                        Cookie.set('token', login_res.data.sessionToken, { expires: 7, secure: true });
                        Cookie.set('name', login_res.data.user.first_name, { expires: 7, secure: true });
                        Cookie.set('bool', login_res.data.user.user_id, { expires: 7, secure: true });
                        Cookie.set('srge', login_res.data.user.user_email, { expires: 7, secure: true });

                        // Set permissions cookie
                        const keys = Object.keys(login_res.data.user.permissions);
                        const highest_perm_level = keys.find(key => login_res.data.user.permissions[key] === true);
                        Cookie.set('levs', highest_perm_level, { expires: 7, secure: true });

                        this.$emit("authenticated", true);
                        // this.$router.replace({ name: "projects" }).catch(err => { console.log(err) });
                        this.$router.replace({ name: "task_dashboard" }).catch(err => { console.log(err) });
                    } else {
                        this.showAccessCodeForm = true;
                        setTimeout(() => {
                            this.$refs.mfa_field.focus();
                            // this.$refs.mfa_field.value = null;
                        }, 50);
                    }
                } else {
                    this.$emit("authenticated", false);
                    this.$feedback.error( login_res.data.message, 8000 );
                    //this.close();
                }
            } catch ( error ) {
                    console.log(error);
            } finally {
                this.login_wait = false;
            }
        },
        
        mfa: async function () {
            //do the stuff to verify mfa. send email and token
            try {
                if (this.login_wait) return;
                this.login_wait = true;

                this.$refs.auth_form.validate();
                if (this.auth_valid) {

                    const cred_url = `${appUrls.api}/api/mfa`;
                    const field_data = {
                        username: this.input.username.trim().toLowerCase(),
                        token: this.accessCode,
                        fingerprint: this.fingerprint,
                    }

                    const access_res = await axios.post(cred_url, {
                        headers: { "content-type": "application/json" },
                        data: field_data
                    })

                    if (access_res.data.outcome) {
                        if (access_res.data.action == 'login') {
                            // Set secure cookies upon successful login
                            Cookie.set('token', access_res.data.sessionToken, { expires: 7, secure: true });
                            Cookie.set('name', access_res.data.user.first_name, { expires: 7, secure: true });
                            Cookie.set('bool', access_res.data.user.user_id, { expires: 7, secure: true });
                            Cookie.set('srge', access_res.data.user.user_email, { expires: 7, secure: true });

                            // Set permissions cookie
                            const keys = Object.keys(access_res.data.user.permissions);
                            const highest_perm_level = keys.find(key => access_res.data.user.permissions[key] === true);
                            Cookie.set('levs', highest_perm_level, { expires: 7, secure: true });

                            this.$emit("authenticated", true);
                            // this.$router.replace({ name: "projects" }).catch(err => { console.log(err) });
                            this.$router.replace({ name: "task_dashboard" }).catch(err => { console.log(err) });
                        }
                    } else {
                        this.$feedback.error( access_res.data.message, 8000 );
                        if (access_res.data.action === "restart") {
                            this.accessCode = null;
                            this.showAccessCodeForm = false;
                        }
                    }

                }
            } catch (error) {
                console.log(error)
            } finally {
                this.login_wait = false;
            }
        },


        resetPass: async function () {
            try {
                const reset_password = await axios.post(`${appUrls.api}/api/resetpw`, {
                    headers: { "content-type": "application/json" },
                    email_address: this.reset_email.trim(),
                        source: 'client'
                })

                if (reset_password.data.outcome) {
                    //console.log(reset_password.data)
                    this.$feedback.success( reset_password.data.message, 8000 );
                    this.forgotDialog = false;
                }
            } catch (error) {
                console.log(error);
            }
        },

        resetClear() {
            this.$refs.form.reset()
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#signin_wrapper {
    width: 100%;
    height: 100%;
}

#login {
    width: 29%;
    margin: 2% auto;
    padding: 3%;
    text-align: center;
    font-size: .8rem;
    background: rgba(255, 255, 255, 0.85);
    border-radius: 8px;
}

#login_btn {
    padding: 4px;
    width: 36%;
    font-size: 1.3em !important;
}

.mnt_image {
    background-position: top left;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;
}

.return_link {
    font-size: 1.25rem;
    text-decoration: none;
    /* mdi-keyboard-backspace */
}

.signin_title {
    font-size: 2rem !important;
    letter-spacing: 0.05rem;
}
</style>


// WEBPACK FOOTER //
// src/components/SignIn.vue